export default "__VITE_ASSET__10ylXKv8__"